import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess } from "./actions"
import { post } from 'helpers/api_helper'
import cookieHelper from "helpers/getCookieData"


const userLogin = async (user) => await post('/auth/login', user)

function* loginUser({ payload: { user, history } }) {
  try {
    const { success, data } = yield call(userLogin, {
      email: user.email,
      password: user.password,
      login_type: user.login_type
    });

    if(success){
      cookieHelper.setCookie("_vslaccdt", JSON.stringify(data), 1)
      cookieHelper.setCookie('token', data.token, 1)
      localStorage.setItem('access_token', data.token, 1)

      yield put(loginSuccess(data))
      if(user?.login_type == 'admin'){
        window.location.href = '/dashboard';
        // history.push("/dashboard")
      }else{
        window.location.href = '/reports';
        // history.push("/reports")
      }
    }
  } catch (error) {
    yield put(apiError('invalid login credentials'))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    cookieHelper.deleteCookie("authUser")
    cookieHelper.deleteCookie("access_token")
    cookieHelper.deleteCookie("refresh_token")
    cookieHelper.deleteCookie("clinic")
    history.push("/")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
